import { getUserFriendlyMetricLabel } from 'modules/messagingInsights/utils';

export const CAMPAIGNS_TIMESERIES_METRICS = [
  'TotalSent',
  'TotalClicks',
  'TotalDelivered',
  'TotalOpens',
  'TotalBounces',
  'TotalUnsubscribes',
];

export const CAMPAIGNS_TABLE_METRICS = [
  'ClickRate',
  'DeliveryRate',
  'OpenRate',
  'BounceRate',
  'UnsubscribeRate',
];

export const TOTAL_SENT_METRIC_NAME = CAMPAIGNS_TIMESERIES_METRICS[0];
export const TOTAL_SENT_METRIC_LABEL = getUserFriendlyMetricLabel(TOTAL_SENT_METRIC_NAME);
